var map = {
	"./administration.svg": 1525,
	"./categories.svg": 1775,
	"./client.svg": 45202,
	"./clients.svg": 47341,
	"./configuration.svg": 64235,
	"./invoices.svg": 60731,
	"./myDashboard.svg": 7807,
	"./permission.svg": 68310,
	"./products.svg": 25247,
	"./purchasesOrder.svg": 54663,
	"./purchasesRequests.svg": 47103,
	"./requestsForProposal.svg": 9948,
	"./supplier.svg": 22827,
	"./suppliers.svg": 3938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42755;